// libs
import { styled } from '@nykaa/ui-components';

// constants
import {
  BREAKPOINTS,
  MEDIA_BREAKPOINTS,
  DWEB_HEADER_HEIGHT,
  BASE_GUTTER_SPACE,
  PRODUCT_IMAGE_CONTAINER_SPACE,
  DWEB_MAX_WIDTH,
} from 'shared/styles/base';

export const DetailContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing240}`};
  }
`;

export const ImageContainerMobile = styled.div`
  display: flex;
  padding: ${({ theme }) => `0 0 0 ${theme.spacing.spacing50}`};
  position: relative;
  flex-flow: wrap;
  width: 590px;
  margin-right: ${({ theme }) => theme.spacing.spacing200};
  height: max-content;
  @media (max-width: ${DWEB_MAX_WIDTH}px) {
    margin-right: ${({ theme }) => theme.spacing.spacing120};
  }
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100%;
    padding: 0;
  }

  @media (min-width: ${BREAKPOINTS.MOBILE}px) and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    justify-content: center;
  }

  @media (max-width: ${BREAKPOINTS.TABLET}px) {
    margin-right: ${({ theme }) => theme.spacing.spacing100};
  }

  ${MEDIA_BREAKPOINTS.MOBILE} {
    width: 100%;
    padding: 0px;
    margin: ${({ theme }) => `0 auto ${theme.spacing.spacing40}`};
  }
`;

export const ImageContainerDesktop = styled(ImageContainerMobile)`
  align-self: flex-start;
  position: sticky;
  z-index: 1;
  top: ${DWEB_HEADER_HEIGHT + BASE_GUTTER_SPACE * 6}px;
`;
export const ProductInfoContainer = styled.div`
  width: calc(100% - ${PRODUCT_IMAGE_CONTAINER_SPACE}px);
`;
